import { render, staticRenderFns } from "./FolderNewDialog.vue?vue&type=template&id=2fac06fa&"
import script from "./FolderNewDialog.vue?vue&type=script&lang=ts&"
export * from "./FolderNewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports